export default __webpack_public_path__ + "static/media/1386.2f02cdba.png";